const LINK_PANEL_MODAL = "linkPanelContainer";
const LINK_PANEL_OPTION_LINK = "link-radio";
const LINK_PANEL_OPTION_ANCHOR = "anchor-radio";
const LINK_PANEL_URL_INPUT = "linkPanelInput";
const LINK_PANEL_NEW_TAB_CHECKBOX = "linkPanelBlankCheckbox";
const LINK_PANEL_NOREFERRER_CHECKBOX = "linkPanelNoreferrerCheckbox";
const LINK_PANEL_NOFOLLOW_CHECKBOX = "linkPanelRelCheckbox";
const LINK_PANEL_SPONSORED_CHECKBOX = "linkPanelSponsoredCheckbox";
const LINK_PANEL_ANCHOR_CONTENT = "linkPanelAnchorContent";
const LINK_PANEL_MODAL_SAVE_BUTTON = "actionButtonSave";
const LINK_PANEL_MODAL_REMOVE_BUTTON = "linkPanelContainerRemove";

var dataHooks = /*#__PURE__*/Object.freeze({
	__proto__: null,
	LINK_PANEL_ANCHOR_CONTENT: LINK_PANEL_ANCHOR_CONTENT,
	LINK_PANEL_MODAL: LINK_PANEL_MODAL,
	LINK_PANEL_MODAL_REMOVE_BUTTON: LINK_PANEL_MODAL_REMOVE_BUTTON,
	LINK_PANEL_MODAL_SAVE_BUTTON: LINK_PANEL_MODAL_SAVE_BUTTON,
	LINK_PANEL_NEW_TAB_CHECKBOX: LINK_PANEL_NEW_TAB_CHECKBOX,
	LINK_PANEL_NOFOLLOW_CHECKBOX: LINK_PANEL_NOFOLLOW_CHECKBOX,
	LINK_PANEL_NOREFERRER_CHECKBOX: LINK_PANEL_NOREFERRER_CHECKBOX,
	LINK_PANEL_OPTION_ANCHOR: LINK_PANEL_OPTION_ANCHOR,
	LINK_PANEL_OPTION_LINK: LINK_PANEL_OPTION_LINK,
	LINK_PANEL_SPONSORED_CHECKBOX: LINK_PANEL_SPONSORED_CHECKBOX,
	LINK_PANEL_URL_INPUT: LINK_PANEL_URL_INPUT
});

export { LINK_PANEL_MODAL as L, LINK_PANEL_NOREFERRER_CHECKBOX as a, LINK_PANEL_NOFOLLOW_CHECKBOX as b, LINK_PANEL_SPONSORED_CHECKBOX as c, dataHooks as d, LINK_PANEL_URL_INPUT as e, LINK_PANEL_NEW_TAB_CHECKBOX as f, LINK_PANEL_ANCHOR_CONTENT as g, LINK_PANEL_OPTION_LINK as h, LINK_PANEL_OPTION_ANCHOR as i, LINK_PANEL_MODAL_SAVE_BUTTON as j, LINK_PANEL_MODAL_REMOVE_BUTTON as k };
//# sourceMappingURL=dataHooks-8eb1301a.js.map
